import React, { useEffect, useState } from "react";
import axiosClient from "../../axios";
import { Link } from "react-router-dom";

const CustomerReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [processingId, setProcessingId] = useState(null);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    setLoading(true);
    try {
      const response = await axiosClient.get("/api/customer-says");
      setReviews(response.data);
      setError("");
    } catch (err) {
      setError("Failed to fetch reviews.");
    } finally {
      setLoading(false);
    }
  };

  const deleteReview = async (id) => {
    if (!window.confirm("Are you sure you want to delete this review?")) return;

    try {
      setProcessingId(id);
      await axiosClient.delete(`/api/customer-says/${id}`);
      setReviews((prev) => prev.filter((review) => review.id !== id));
    } catch (err) {
      alert("Failed to delete review.");
    } finally {
      setProcessingId(null);
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  return (
    <div className="container mt-4">
      {/* Header with Add New button */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Customer Reviews</h3>
        <Link to="/xl-admin/add-customer-reviews" className="btn btn-primary">
          + Add New
        </Link>
      </div>

      <div className="row">
        {reviews.length === 0 ? (
          <div className="col">
            <div className="alert alert-info">No reviews found.</div>
          </div>
        ) : (
          reviews.map((review) => (
            <div key={review.id} className="col-md-4 mb-4">
              <div className="card h-100 shadow-sm">
                {review.image && (
                  <img
                    src={review.image}
                    className="card-img-top"
                    alt={review.name}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                )}
                <div className="card-body">
                  <h5 className="card-title">{review.name}</h5>
                  <p className="card-text">{review.what_they_said}</p>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteReview(review.id)}
                    disabled={processingId === review.id}
                  >
                    {processingId === review.id ? "Deleting..." : "Delete"}
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CustomerReviews;
